import {
  Contacts,
  MembershipStatusEnum,
  Workspace,
} from '@sr-sdks/api-sdk-axios';

export type WorkspaceContactFieldName = keyof Contacts;

type WorkspaceContactFieldDefinition = {
  isVisible: (workspace?: Workspace) => boolean;
  label: string;
  name: WorkspaceContactFieldName;
};

export const WORKSPACE_CONTACT_FIELDS = [
  {
    isVisible: () => true,
    label: 'Primary Contact',
    name: 'primaryContactUserId',
  },
  {
    isVisible: (workspace?: Workspace) =>
      Boolean(workspace?.addons?.collectionAccounts),
    label: 'Disbursement Contact',
    name: 'dsContactUserId',
  },
  {
    isVisible: (workspace?: Workspace) =>
      Boolean(workspace?.addons?.collectionAccounts),
    label: 'Disbursement Notices Contact',
    name: 'dsNoticesContactUserId',
  },
  {
    isVisible: (workspace?: Workspace) =>
      workspace?.membershipStatus === MembershipStatusEnum.CurrentMember,
    label: 'Annual General Meeting Contact',
    name: 'agmContactUserId',
  },
  {
    isVisible: (workspace?: Workspace) =>
      workspace?.membershipStatus === MembershipStatusEnum.CurrentMember,
    label: 'Competing Claims Contact',
    name: 'competingClaimContactUserId',
  },
] as const satisfies readonly WorkspaceContactFieldDefinition[];

export const getVisibleWorkspaceContactFields = (workspace?: Workspace) =>
  WORKSPACE_CONTACT_FIELDS.filter((field) => field.isVisible(workspace));

export const isMissingContactValue = (value?: null | string) => {
  return value == null || value.trim() === '';
};

export const getWorkspaceOwnerContactDefaults = (
  contacts: Contacts | undefined,
  workspaceOwnerUserId: string,
) => {
  return WORKSPACE_CONTACT_FIELDS.reduce<Partial<Contacts>>(
    (defaults, field) => {
      if (isMissingContactValue(contacts?.[field.name])) {
        defaults[field.name] = workspaceOwnerUserId;
      }

      return defaults;
    },
    {},
  );
};
